__turbopack_context__.v({
  "divider": "advisor-client-module__sBKPIq__divider",
});
